import React from 'react';
import { CtaButton } from './ui/CtaButton';
const STUDIO = 'https://cdn.magicpatterns.com/patterns/generated-images/b3a8acf5-cf08-4526-827a-0cb13bdd3241.jpg';
export function FinalCtaSection() {
  return <section className="relative w-full overflow-hidden bg-forestDeep" aria-labelledby="final-heading" data-id="element-59" data-mp="3qt9kcy8plkqx">
      <img src={STUDIO} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-[0.12]" loading="lazy" data-id="element-60" data-mp="3vs43k1al9bbk" />
      <div className="relative mx-auto w-full max-w-2xl px-5 py-12 text-center sm:px-8 sm:py-16" data-id="element-61" data-mp="33505yhdtrz9t">
        <h2 id="final-heading" className="font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ivory sm:text-4xl" data-id="element-62" data-mp="3820auoyxuvzc">
          Your next class doesn’t have to
          <span className="block text-goldSoft" data-id="element-63" data-mp="2fdl04emuaztt">start with a blank page.</span>
        </h2>

        <p className="mx-auto mt-4 max-w-sm text-[0.9rem] leading-relaxed text-ivory/75 sm:text-base" data-id="element-64" data-mp="2kcfgzb18yeba">
          120 classes. 6 professional volumes. One organized teaching library.
        </p>

        <p className="mt-4 font-serif text-base uppercase tracking-label text-ivory/85 sm:text-xl" data-id="element-65" data-mp="28cni9nynx3ou">
          Open <span className="text-goldSoft" data-id="element-66" data-mp="23l5gixotez2t">•</span> Choose{' '}
          <span className="text-goldSoft" data-id="element-67" data-mp="1yn3zeiay99tz">•</span> Teach
        </p>

        <p className="mt-5 font-serif text-[0.68rem] uppercase tracking-label text-ivory/60" data-id="element-68" data-mp="1ymu7gp6cgsln">
          Yoga Teacher System™
        </p>
        <p className="mt-1 font-serif text-4xl font-semibold leading-none text-ivory sm:text-5xl" data-id="element-69" data-mp="1pmp7v17e6yi1">
          $19 <span className="text-base font-normal text-ivory/60" data-id="element-70" data-mp="1kmt3h0us951y">USD</span>
        </p>

        <div className="mt-6" data-id="element-71" data-mp="1fo9jh5zr23c8">
          <CtaButton tone="light" label="Get instant access" microcopy="One-Time Purchase • Instant Access • 7-Day Guarantee" data-id="element-72" data-mp="1fpb524ee6887" />
        </div>
      </div>
    </section>;
}